const PATH = {
  root: "/",
  pricing: "/pricing",
  partner: "/partner",
  features: "/features",
  featuressection: "/featuressection",
  industry: "/industry/:id",
  industrydata: "/industrydata",
  register: "/register",
  login: "/login",
  pageNotFound: { root: "*" },
  change_password: "/change-password",
  logout: "/logout",
  dashboard: "/dashboard",
  items: "/items",
  bulkUploadItems: "/items/bulkupload",
  // corrected
  itemDetails: "/items/details/:id",

  category: "/items/category",
  unit: "/items/unit",
  location: "/items/location",
  addItems: "/items/add",
  services: "/services",
  bulkUploadServices: "/services/bulkupload",
  addServices: "/add-services",
  //corrected
  servicesCategory: "/services/categories",
  party: "/party",
  bulkUploadParty: "/party/bulkupload",
  addParty: "/party/addParty",
  editParty: "/party/edit/:id",
  partyDetails: "/party/details/:id",
  purchase: "/purchases",
  purchaseOrder: "/purchases/order/:id?",
  createPurchase: "/purchases/create/:id?",
  purchase_order_list: "/purchases/order/list",
  sale: "/sales",
  saleOrder: "/sales/order/:id?",
  saleOrderlist: "/sales/order/list",
  saleInvoice: "/sale-invoice/:id?",
  //createSale: "/sales/create/:id?",
  //createSale: "/sales/create",
  //createSale: "/sales/create/:id?",
  returns: "/returns",
  transaction: "/transaction",
  transactionDetail: "/transactionDetail",
  expenses: "/expenses",
  expensesCategory: "/expenses/categories",
  createbusiness: "/createbusiness",
  business: "/business",
  addBusiness: "/add-business/:id?",
  privacy: "/privacy-policy",
  terms: "/terms-condition",
  account: "/account",
  reports: "/reports",
  employee: "/employee",
  shift: "/employee/shift",
  addEmployee: "/employee/add",
  editEmployee: "/employee/edit/:id",
  attendance: "/employee/attendance",
  zoomControls: "/zoomControls",
  prefix: "/prefix",
  createSale: "/sales/create",
  editSale: "/sales/create/:id",
};

export default PATH;
